import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { Palette } from "../AppConfig";
import BSL_ControlContainer from "./BSL_ControlContainer";
import { Tooltip } from "@material-ui/core";

const BSL_ToggleButton = withStyles((theme) => ({
    root: {
        fontSize: theme.brand.FIELDERS ? "14px" : "12px",
        fontFamily: theme.typography.fontFamilySecondary,
        fontWeight: theme.brand.FIELDERS ? "200" : "600",
        padding: "4px 12px",
        minWidth: "35px",
        color: theme.brand.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue,
        borderRadius: theme.brand.FIELDERS ? "4px" : "0px",
        background: "#00000000",
        lineHeight: 1,
        "&:hover": {
            color: "white !important",
            background: theme.brand.FIELDERS
                ? Palette.Fielders.HoverButtonBlue + " !important"
                : Palette.Lysaght.LightBlue + " !important",
        },
        "&:hover label": {
            color: "white",
        },
        "& .MuiToggleButton-root.Mui-selected": {
            background: theme.brand.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue,
            color: "white",
        },
    },
    label: {
        whiteSpace: "nowrap",
    },
}))(ToggleButton);

const BSL_ToggleButtonTight = withStyles((theme) => ({
    root: {
        fontSize: theme.brand.FIELDERS ? "12px" : "11px",
        fontFamily: theme.typography.fontFamilySecondary,
        fontWeight: theme.brand.FIELDERS ? "200" : "600",
        padding: "2px 8px",
        minWidth: "35px",
        background: "#00000000",
        lineHeight: 1,
        color: theme.brand.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue,
        height: "24px",
        borderRadius: theme.brand.FIELDERS ? "4px" : "0px",
        "&:hover": {
            color: "white !important",
            background: theme.brand.FIELDERS
                ? Palette.Fielders.HoverButtonBlue + " !important"
                : Palette.Lysaght.LightBlue + " !important",
        },
        "&:hover label": {
            color: "white",
        },
        "& .MuiToggleButton-root.Mui-selected": {
            color: theme.brand.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.LightBlue,
            color: "white",
        },
    },
}))(ToggleButton);

const useStyles = makeStyles((theme) => ({
    label: {
        flex: "1",
        font: "16px " + theme.typography.fontFamilySecondary,
        color: Palette.Control.DarkGrey,
        padding: "4px 0px",
        textAlign: "start",
    },
    label_tight: {
        font: "14px " + theme.typography.fontFamilySecondary,
        padding: "6px 0px 6px 0px",
    },
    subtitle: {
        flex: "1",
        font: "13px " + theme.typography.fontFamilySecondary,
        color: "#6B8799",
        textAlign: "end",
        padding: "4px 0px",
    },

    input: {
        padding: "2px",
        font: "16px " + theme.typography.fontFamilySecondary,
        padding: "10px 8px",
        border: "1px solid #6B8799",
    },
    textField: {
        borderRadius: "0px",
    },
    notchedOutline: {
        "&:focus": {
            borderWidth: "1px",
            borderColor: "#002D62 !important",
        },
    },
    disabled: {
        backgroundColor: Palette.Control.LightGrey,
    },
    button_group: {
        width: "fit-content",
        background: "#ffffffcc",
        margin: "2px 2px 2px 0px",
        padding: "4px 4px 4px 4px",
        border: "1px solid " + Palette.Control.DarkBlueTrans,
        display: "flex",
        flexDirection: "row",
        borderRadius: theme.brand.FIELDERS ? "4px" : "0px",
    },
    vertical: {
        flexDirection: "column",
    },
    button_vertical: {
        padding: "2px",
    },
    group_large: {
        gap: "8px",
        padding: "8px 8px",
        "& .MuiToggleButton-root": {
            padding: "10px 20px",
            margin: 0,
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: theme.brand.FIELDERS ? "4px" : "0px",
        },
    },
    group_tight: {
        padding: "1px 1px 2px 1px",
        boxShadow: "none",
        margin: "0px 2px 2px 0px",
        flexWrap: "wrap",
    },
    selected: {
        "& .MuiToggleButton-root.Mui-selected": {
            background: theme.brand.FIELDERS
                ? Palette.FieldersBlue + " !important"
                : Palette.Lysaght.DarkBlue + " !important",
            color: "white !important",
        },
    },
    item_selected: {
        background: theme.brand.FIELDERS
            ? Palette.FieldersBlue + " !important"
            : Palette.Lysaght.DarkBlue + " !important",
        color: "white !important",
    },
}));

export default function SegmentedButtonGroup(props) {
    const classes = useStyles();
    const fielders = window.FIELDERS;
    const [selected, setSelected] = React.useState(null);
    const isExclusive = props?.exclusive === undefined ? true : props.exclusive;

    const handleAlignment = (event, newValue) => {
        if (newValue === null && props.items.length > 1 && !props.allowToggle) {
            //don't allow toggle off of currently selected value.
            if (props?.onClick) props.onClick(event, newValue ? newValue : props.value);
            return;
        }
        if (newValue && !isExclusive && !Array.isArray(newValue)) {
            newValue = [];
        }
        if (props.onChange) props.onChange(event, newValue);
    };
    const items = [];
    const valueKey = props.valueKey ? props.valueKey : "Key";
    const displayKey = props.displayKey ? props.displayKey : "Display";

    if (props.items) {
        let list = props.items;
        if (typeof list === "object" && !Array.isArray(list)) list = Object.keys(list);

        if (typeof list[Symbol.iterator] === "function")
            for (var item of list) {
                if (props.tight) {
                    if (typeof item === "string" || typeof item === "number") {
                        items.push(
                            <BSL_ToggleButtonTight
                                key={item}
                                value={item}
                                disabled={props.disabled}
                                fielders={fielders}
                                className={
                                    (props.vertical ? classes.button_vertical : "") +
                                    (props.value === item ? " " + classes.item_selected : "")
                                }
                                style={props.ButtonStyle}
                            >
                                {item}
                            </BSL_ToggleButtonTight>
                        );
                    } else if (item.disabled || props.disabled) {
                        let is_selected = false;
                        if (props.value === item[valueKey]) {
                            is_selected = true;
                        }
                        if (props.value && Array.isArray(props.value) && props.value.includes(item[valueKey])) {
                            is_selected = true;
                        }
                        items.push(
                            <Tooltip
                                title={
                                    item.disabled && item.disabledTooltip
                                        ? item.disabledTooltip
                                        : item.tooltip
                                        ? item.tooltip
                                        : ""
                                }
                            >
                                <div>
                                    <BSL_ToggleButtonTight
                                        key={item[valueKey]}
                                        value={item[valueKey]}
                                        className={
                                            (props.vertical ? classes.button_vertical : "") +
                                            (is_selected ? " " + classes.item_selected : "")
                                        }
                                        disabled={item.disabled || props.disabled}
                                        fielders={fielders}
                                        style={props.ButtonStyle}
                                    >
                                        {item[displayKey]}
                                    </BSL_ToggleButtonTight>
                                </div>
                            </Tooltip>
                        );
                    } else {
                        let is_selected = false;
                        if (props.value === item[valueKey]) {
                            is_selected = true;
                        }
                        if (props.value && Array.isArray(props.value) && props.value.includes(item[valueKey])) {
                            is_selected = true;
                        }
                        items.push(
                            <Tooltip
                                title={
                                    item.disabled && item.disabledTooltip
                                        ? item.disabledTooltip
                                        : item.tooltip
                                        ? item.tooltip
                                        : ""
                                }
                            >
                                <BSL_ToggleButtonTight
                                    key={item[valueKey]}
                                    value={item[valueKey]}
                                    className={
                                        (props.vertical ? classes.button_vertical : "") +
                                        (is_selected ? " " + classes.item_selected : "")
                                    }
                                    disabled={item.disabled || props.disabled}
                                    fielders={fielders}
                                    style={props.ButtonStyle}
                                >
                                    {item[displayKey]}
                                </BSL_ToggleButtonTight>
                            </Tooltip>
                        );
                    }
                } else {
                    if (typeof item === "string") {
                        items.push(
                            <BSL_ToggleButton
                                key={item}
                                value={item}
                                disabled={props.disabled}
                                fielders={fielders}
                                className={
                                    (props.vertical ? classes.button_vertical : "") +
                                    (props.value === item ? " " + classes.item_selected : "")
                                }
                                style={props.ButtonStyle}
                            >
                                {item}
                            </BSL_ToggleButton>
                        );
                    } else if (item.disabled || props.disabled) {
                        items.push(
                            <Tooltip
                                title={
                                    item.disabled && item.disabledTooltip
                                        ? item.disabledTooltip
                                        : item.tooltip
                                        ? item.tooltip
                                        : ""
                                }
                            >
                                <BSL_ToggleButton
                                    key={item[valueKey]}
                                    value={item[valueKey]}
                                    className={
                                        (props.vertical ? classes.button_vertical : "") +
                                        (props.value === item[valueKey] ? " " + classes.item_selected : "")
                                    }
                                    disabled={item.disabled || props.disabled ? true : false}
                                    fielders={fielders}
                                    style={props.ButtonStyle}
                                >
                                    {item[displayKey]}
                                </BSL_ToggleButton>
                            </Tooltip>
                        );
                    } else {
                        items.push(
                            <Tooltip
                                title={
                                    item.disabled && item.disabledTooltip
                                        ? item.disabledTooltip
                                        : item.tooltip
                                        ? item.tooltip
                                        : ""
                                }
                            >
                                <BSL_ToggleButton
                                    key={item[valueKey]}
                                    value={item[valueKey]}
                                    className={
                                        (props.vertical ? classes.button_vertical : "") +
                                        (props.value === item[valueKey] ? " " + classes.item_selected : "")
                                    }
                                    disabled={item.disabled || props.disabled}
                                    fielders={fielders}
                                    style={props.ButtonStyle}
                                >
                                    {item[displayKey]}
                                </BSL_ToggleButton>
                            </Tooltip>
                        );
                    }
                }
            }
    }

    return (
        <BSL_ControlContainer {...props}>
            <ToggleButtonGroup
                value={
                    selected !== null
                        ? selected
                        : props.value !== undefined
                        ? !isExclusive && !Array.isArray(props.value)
                            ? [props.value]
                            : props.value
                        : !isExclusive
                        ? []
                        : ""
                }
                exclusive={isExclusive}
                onChange={handleAlignment}
                disabled={props.disabled}
                fielders={fielders}
                orientation={props.vertical ? "vertical" : "horizontal"}
                className={
                    classes.button_group +
                    (props.vertical ? " " + classes.vertical : "") +
                    (props.large ? " " + classes.group_large : "") +
                    " " +
                    (props.tight || props.extratight ? classes.group_tight : "") +
                    " " +
                    ((selected !== null ? selected : props.value) ? classes.selected : "")
                }
                style={{ flexWrap: props.allowWrap ? "wrap" : "" }}
            >
                {items}
            </ToggleButtonGroup>
        </BSL_ControlContainer>
    );
}
